<app-sidenav>
  <div class="container-fluid p-5">
    <h2 class="page-title mt-5">Solicitação de garantia</h2>
    <div class="row mt-4 p-4 custom-box">
      <div class="col-lg-8 text-left">
        <h2 class="page-title">
          {{dadoInstituicao.nomeInstituicao}}
        </h2>
      </div>
      <div class="col-lg-4 text-right text-end">
        <h2 class="page-title">
          Liquidação: {{dadoInstituicao.dataLiquidacao | date:"dd/MM/yyyy"}}
        </h2>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-center mt-3">
      <mdb-stepper #stepper class="col-12" [linear]="false">
        <!--<mdb-step name="Endereço">
          <div class="row col-12">
            <form class="box-form col-12 p-5" [formGroup]="formEndereco">
              <h3 class="form-title  text-center">1 - Endereço</h3>
              <hr>
              <div class="form-row">
                <div class="form-group col-3">
                  <label class="form-label" >CEP <b class="text-danger">*</b></label>
                  <input type="text" name="cep" (change)="consultaEndereco($event)" maxlength="9" mask="00000-000" formControlName="cep"
                    class="form-control form-icon-trailing" />
                    <span class="error-form ml-2" *ngIf="cep.invalid && (cep.dirty || cep.touched) || exibirErro">Campo obrigatório.</span>
                  </div>
                <div class="form-group col-6">
                  <label class="form-label" >Endereço <b class="text-danger">*</b></label>
                  <input type="text" name="nomeRua" formControlName="endereco"
                    class="form-control form-icon-trailing" />
                  <span class="error-form ml-2" *ngIf="endereco.invalid && (endereco.dirty || endereco.touched) || exibirErro">Campo obrigatório, Minimo 5 caracteres.</span> -->

                  <!-- <span class="error-form ml-2" *ngIf="endereco.errors?.minLength"></span> -->

                 <!-- <span class="error-form ml-2" *ngIf="endereco.errors?.maxLength">Máximo 50 caracteres.</span>
                </div>
                <div class="col-md-3">
                  <label class="form-label" >Número/Complemento <b class="text-danger">*</b></label>
                  <input type="text" name="bairro" formControlName="complemento"
                    class="form-control form-icon-trailing" />
                    <span class="error-form ml-2" *ngIf="complemento.invalid && (complemento.dirty || complemento.touched) || exibirErro">Campo obrigatório.</span>
                    <span class="error-form ml-2" *ngIf="complemento.errors?.maxLength">Máximo 50 caracteres.</span>
                   </div> -->

                <!-- <div class="form-group col-3 ">
                  <label class="form-label" >Número <b class="text-danger">*</b></label>
                  <input type="text" name="numero" formControlName="numero"
                    class="form-control form-icon-trailing" />
                   <span class="error-form ml-2" *ngIf="ruaAvenida.invalid && (ruaAvenida.dirty || ruaAvenida.touched)">Campo obrigatório.</span>
                </div> -->

              <!--</div>
              <div class="form-row">
                <div class="form-group col-3">
                  <label class="form-label" >País <b class="text-danger">*</b></label>
                  <select type="text" name="pais" formControlName="pais"
                    class="form-control form-icon-trailing">
                    <option *ngFor="let option of arrayDDi" [value]="option.name">{{option.name}}</option>
                  </select>
                  <span class="error-form ml-2" *ngIf="pais.invalid && (pais.dirty || pais.touched) || exibirErro">Campo obrigatório.</span>
                </div>
                <div class="form-group col-3">
                  <label class="form-label" >Estado <b class="text-danger">*</b></label>
                  <select type="text" name="estado" formControlName="estado"
                    class="form-control form-icon-trailing">
                    <option *ngFor="let option of arrayEstados" [value]="option.sigla">{{option.nome}}</option>
                  </select>
                   <span class="error-form ml-2" *ngIf="estado.invalid && (estado.dirty || estado.touched) || exibirErro">Campo obrigatório.</span>
                  </div>
                <div class="form-group col-3">
                  <label class="form-label" >Cidade <b class="text-danger">*</b></label>
                  <input type="text" name="cidade" formControlName="cidade"
                    class="form-control form-icon-trailing" />
                    <span class="error-form ml-2" *ngIf="cidade.invalid && (cidade.dirty || cidade.touched) || exibirErro">Campo obrigatório.</span>
                    <span class="error-form ml-2" *ngIf="cidade.errors?.maxLength">Máximo 50 caracteres.</span>
                  </div>
                <div class="form-group col-3">
                  <label class="form-label" >Bairro <b class="text-danger">*</b></label>
                  <input type="text" name="bairro" formControlName="bairro"
                    class="form-control form-icon-trailing" />
                    <span class="error-form ml-2" *ngIf="bairro.invalid && (bairro.dirty || bairro.touched) ||  exibirErro">Campo obrigatório.</span>
                    <span class="error-form ml-2" *ngIf="bairro.errors?.maxLength">Máximo 50 caracteres.</span>
                  </div>
              </div> -->
                <!-- <div class="form-row">
                  <div class="col-md-4">
                    <label class="form-label" >Complemento <b class="text-danger">*</b></label>
                    <input type="text" name="bairro" formControlName="complemento"
                      class="form-control form-icon-trailing" />
                  </div>
                </div> -->
            <!--  <div class="form-row mt-4">
                <div class="col-12 d-flex justify-content-center">
                  <button (click)="cadastroEndereco()" class="btn">Continuar</button>
                </div>
              </div>
            </form>
          </div>
        </mdb-step> -->
        <!-- Endereço Form -->
        <mdb-step name="Dados Garantia">
          <div class="row col-12 ">
            <form class="box-form col-12 p-5" >
              <h3 class="form-title  text-center">1 - Dados de Depósito</h3>
              <hr>
              <div class="form-row mt-4 d-flex justify-content-center">
                <div class="form-group col-8">
                  <form [formGroup]="formPagamentoOnline">
                    <div class="custom-box mt-4 p-5">
                      <div class="col-12 text-center">
                        <h2 class="custom-box-title">Dados Bancários para Depósito</h2>
                      </div>
                      <div class="col-12 text-center">
                        <p class="custom-box-subtitle">
                          Para receber o pagamento da garantia, a conta deve estar vinculada ao CNPJ do credor (Pessoa Jurídica). Selecione os dados bancários para prosseguir.
                        </p>
                      </div>
                      <div class="form-row mt-3">
                        <div class="form-group col-12">
                          <label class="form-label" >Banco para depósito <b class="text-danger">*</b></label>
                          <select data-testid="banco-deposito-solicitacao" type="text" name="bancoId" formControlName="bancoId"
                            class="form-control form-adaptable form-icon-trailing" (change)="onBancoChange($event.target.value)">
                            <option *ngFor="let opt of arrayBancos" [value]="opt.id">{{opt.nome}}</option>
                          </select>
                          <div *ngIf="bancoId.touched && bancoId.invalid" class="text-danger">
                            Selecione um Banco.
                          </div>
                        </div>
                      </div>
                      <div class="form-row mt-3">
                        <div class="form-group col-3">
                          <label class="form-label" >Tipo de conta <b class="text-danger">*</b></label>
                              <select data-testid="tipo-conta-solicitacao" type="text" name="tipoConta" formControlName="tipoContaPagamento"
                              class="form-control form-adaptable form-icon-trailing">
                              <option value="Poupança">Conta Poupança</option>
                              <option value="Conta Corrente">Conta Corrente</option>
                            </select>
                            <div *ngIf="tipoContaPagamento.touched && tipoContaPagamento.invalid" class="alert alert-danger">
                              <span class="error-form ml-2" *ngIf="tipoContaPagamento.invalid && (tipoContaPagamento.dirty || tipoContaPagamento.touched)">Campo obrigatório.</span>
                              <!-- <div *ngIf="confirmaEmail.errors.email">O email informado não é válido.</div> -->
                            </div>
                        </div>
                        <div class="form-group col-3">
                          <label class="form-label" >Agência <b class="text-danger">*</b></label>
                          <input
                          data-testid="agencia-solicitar-garantia"
                          type="text"
                          autocomplete="off"
                          name="agenciaPagamento"
                          formControlName="agenciaPagamento"
                          class="form-control form-adaptable form-icon-trailing"
                          inputmode="numeric"
                          mask="0000"
                          placeholder="0000"/>
                            <div *ngIf="agenciaPagamento.touched && agenciaPagamento.invalid" class="alert alert-danger">
                              <span class="error-form ml-2" *ngIf="agenciaPagamento.invalid && (agenciaPagamento.dirty || agenciaPagamento.touched)">Campo obrigatório.</span>
                            </div>
                        </div>
                        <div class="form-group col-3" *ngIf="this.bancoId.value == '001'">
                          <label class="form-label" >Dígito Agência <b class="text-danger">*</b></label>
                          <input
                            data-testid="digito-agencia-solicitacao"
                            type="text"
                            autocomplete="off"
                            class="form-control form-adaptable"
                            name="digitoAgencia"
                            formControlName="digitoAgencia"
                            maxlength="1"
                            (input)="validateDataBank($event)"/>
                              <div *ngIf="digitoAgencia.touched && digitoAgencia.invalid" class="alert alert-danger">
                                <span class="error-form ml-2" *ngIf="digitoAgencia.invalid && (digitoAgencia.dirty || digitoAgencia.touched)">Campo obrigatório.</span>
                              </div>
                        </div>
                        <div class="form-group col-3">
                          <label class="form-label" >Conta <b class="text-danger">* </b>
                            <i
                              class="fas fa-info-circle"
                              mdbTooltip="Informe a conta sem o dígito"
                              placement="top">
                            </i>
                          </label>
                          <input
                            data-testid="conta-solicitacao"
                            type="text"
                            autocomplete="off"
                            name="contaPagamento"
                            formControlName="contaPagamento"
                            class="form-control form-adaptable form-icon-trailing"
                            maxlength="12"
                            placeholder="00000000"
                            (input)="validateDataBank($event)"/>
                              <div *ngIf="contaPagamento.touched && contaPagamento.invalid" class="alert alert-danger">
                                <span class="error-form ml-2" *ngIf="contaPagamento.invalid && (contaPagamento.dirty || contaPagamento.touched)">Campo obrigatório.</span>
                                <!-- <div *ngIf="confirmaEmail.errors.email">O email informado não é válido.</div> -->
                              </div>
                        </div>
                        <div class="form-gro up col-3">
                          <label class="form-label" >Digito <b class="text-danger">*</b></label>
                          <input
                            data-testid="digito-conta-solicitacao"
                            type="text"
                            autocomplete="off"
                            name="digitoContaPagamento"
                            formControlName="digitoContaPagamento"
                            class="form-control form-adaptable form-icon-trailing"
                            maxlength="1"
                            placeholder="0"
                            (input)="validateDataBank($event)"/>
                              <div *ngIf="digitoContaPagamento.touched && digitoContaPagamento.invalid" class="alert alert-danger">
                                <span class="error-form ml-2" *ngIf="digitoContaPagamento.invalid && (digitoContaPagamento.dirty || digitoContaPagamento.touched)">Campo obrigatório.</span>
                              </div>
                          </div>
                      </div>

                    </div>
                    <!--  -->
                  </form>
                </div>
              </div>
              <hr>
              <h3 class="form-title text-center" *ngIf="exibirRepresentantes">2 - Dados dos Representantes</h3>
              <div class="form-row mt-4 d-flex justify-content-center" *ngIf="exibirRepresentantes">
                <div class="form-group col-8">
                  <form [formGroup]="formEmpresa">
                    <div class="custom-box mt-4 p-5">
                      <div class="col-12 text-center">
                        <h2 class="custom-box-title">Editar dados dos Representantes</h2>
                      </div>
                      <div>
                        <div class="col-12 text-center">
                          <p class="custom-box-subtitle">
                            O Representante Legal indicado deve possuir poderes de representação para assinar o termo em nome do Credor Pessoa Jurídica, de acordo com a documentação Societária e Procuração (se houver) a ser enviada.
                          </p>
                        </div>
                      </div>
                      <div class="form-row mt-3">
                        <div class="form-group col-6">
                          <label class="form-label" >CNPJ da Empresa</label>
                          <input formControlName="cnpjEmpresa" autocomplete="off" mask="AA.AAA.AAA/AAAA-AA" class="form-control form-adaptable form-icon-trailing"/>
                        </div>
                        <div class="form-group col-6">
                          <label class="form-label" >Nome/Razão Social <b class="text-danger">*</b></label>
                          <input data-testid="razao-social-solicitacao" autocomplete="off-" formControlName="nomeEmpresa" maxlength="150" class="form-control form-adaptable form-icon-trailing" />
                          <span class="error-form ml-2" *ngIf="formEmpresa.get('nomeEmpresa')?.hasError('required') && (formEmpresa.get('nomeEmpresa').dirty || formEmpresa.get('nomeEmpresa').touched)">Campo obrigatório.</span>
                          <span class="error-form ml-2" *ngIf="formEmpresa.get('nomeEmpresa')?.hasError('pattern')">Campo contém caracteres inválidos.</span>
                        </div>
                        <div class="form-group col-6">
                          <span class="info-text"><i class="fas fa-info-circle"></i> Campo não editável</span>
                        </div>
                      </div>
                      <hr>

                      <div formArrayName="representantes">
                        <div *ngFor="let rep of representantes.controls; let i = index" [formGroupName]="i">
                          <h2 class="title-section"><i class="fas fa-edit"></i>
                             Representante Legal {{ i + 1}}
                             <span class=" badge badge-solid" *ngIf="i === 0">Obrigatório</span>
                             <span class=" badge badge-outline" *ngIf="i === 1">Se aplicável</span>
                            </h2>
                          <div class="form-row mt-3">
                            <div class="form-group col-12">
                              <label class="form-label" >Nome Completo <b class="text-danger" *ngIf="i === 0">*</b></label>
                              <input data-testid="nome-representante-solicitacao" autocomplete="off-" formControlName="nome" maxlength="150" placeholder="Nome Completo" class="form-control form-adaptable form-icon-trailing" />
                              <span class="error-form ml-2" *ngIf="rep.get('nome').hasError('required') && (rep.get('nome').dirty || rep.get('nome').touched)">Campo obrigatório.</span>

                            </div>
                            <div class="form-group col-6">
                              <label class="form-label" >CPF <b class="text-danger" *ngIf="i === 0">*</b></label>
                              <input data-testid="cpf-representante-solicitacao" autocomplete="off" formControlName="cpf" placeholder="000.000.000-00" mask="000.000.000-00" class="form-control form-adaptable form-icon-trailing" />
                              <span class="error-form ml-2" *ngIf="rep.get('cpf').hasError('required') && (rep.get('cpf').dirty || rep.get('cpf').touched)">Campo obrigatório.</span>
                            </div>
                            <div class="form-group col-6">
                              <label class="form-label" >E-mail <b class="text-danger" *ngIf="i === 0">*</b></label>
                              <input data-testid="email-representante-solicitacao" autocomplete="off-" formControlName="emailPj" placeholder="exemplo@exemplo.com" class="form-control form-adaptable form-icon-trailing" />
                              <span class="error-form ml-2" *ngIf="rep.get('emailPj').hasError('required') && (rep.get('emailPj').dirty || rep.get('emailPj').touched)">Campo obrigatório.</span>
                              <span class="error-form ml-2" *ngIf="rep.get('emailPj')?.hasError('emailInvalid') && rep.get('emailPj')?.dirty">E-mail inválido.</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div *ngIf="editaRepresentantes === false" class="col-12 text-center">
                          <p class="custom-box-subtitle">
                            Já existe um <b>pedido de garantia</b> para esta empresa em fase de validação. Por esse motivo, <b>a edição de representantes não é permitida neste momento</b>. Serão consideradas as <b>mesmas informações já informadas</b>.
                          </p>
                        </div>
                      </div>


                    </div>
                  </form>
                </div>
              </div>

              <div class="form-row mt-4">
                <div class="form-group col-12 d-flex justify-content-center">
                  <button data-testid="botao-voltar-solicitacao" class="btn ml-1 mr-1 button-disabled" (click)="previous()">Voltar</button>
                  <button data-testid="botao-continuar-solicitacao" class="btn ml-1 mr-1" [disabled]="formPagamentoOnline.invalid" (click)="enviarForm()">Continuar</button>
                </div>
              </div>

            </form>

          </div>
        </mdb-step>
      </mdb-stepper>
    </div>
  </div>
</app-sidenav>
